export { getDocumentHref, getDocumentTitle } from "./documentData.js";
export { eventEmit } from "./event";
export { createWindow } from "./createWindow";
export { getRandomNumber } from "./getRandomNumber";
export { getShortNumber } from "./getShortNumber";



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-share-buttons/src/helpers/index.js
// module id = null
// module chunks = 